import { Injectable } from '@angular/core';
import { AppInjector } from '../../app-injector';
import { IntegrationItemServiceInf, StatusString } from '../interfaces/integrations';
import { AzureSyncDialogComponent } from '../../modules/integrations-applications/components/integ-config-dialogs/azure-sync-dialog/azure-sync-dialog.component';
import { AdminService } from 'src/app/core/services/admin.service';
import { Account } from '@mitel/cloudlink-sdk';
import { RBACAuthGuardService } from '../guards/rbac-auth-guard.service';
import { ActionType, CategoryId } from '../utils/rbac.util';

@Injectable({
	providedIn: 'root'
})

// this service will hide whatever implementation we eventually have for gettinng the list of integrations
// types. Right now it is static
export class IntegAzureAdSyncService implements IntegrationItemServiceInf {

	private adminService: AdminService;
	private rbacAuthGuardService: RBACAuthGuardService;

	constructor(  ) 
	{
	}

	initServices()
	{
		if ( !this.adminService )
			this.adminService = AppInjector.injector.get(AdminService);

		if (!this.rbacAuthGuardService)
			this.rbacAuthGuardService = AppInjector.injector.get(RBACAuthGuardService);
	}
	
	getConfigurationDialog() : any
	{
		return AzureSyncDialogComponent;
	}

	isSetupComplete(account: Account) : Promise<boolean>
	{
		this.initServices();
		return this.adminService.doesScimKeyExist(account.accountId);
	}

	handleIntegrationStateChange(account: Account, state: boolean, productsPriorChange?: string[]): Promise<any>
	{
		if ( state == false )
		{
			this.initServices();
			// only invalidate the keys if they exist
			return this.adminService.doesScimKeyExist(account.accountId).then( keysExist => {
				if ( keysExist === true )
				{
					return this.adminService.clearADSyncKeys( account.accountId, "azure" );
				}
				else
				{
					return;
				}
			});
		}
		else
			return; // nothing to implement yet
	}

	getStatusString(account: Account): Promise<StatusString>
	{
		return undefined;
	}

	getConfigButtonLabel(account: Account): Promise<string>
	{
		return undefined;
	}

	isButtonDisabled(account: Account): Promise<boolean>
	{
		return Promise.resolve(false);
	}

	canDeleteIntegration(account: Account): Promise<boolean>
	{
		return Promise.resolve(true);
	}

	getAzureAdSyncData(account: Account): Promise<any> {

		this.initServices();
		return this.adminService.getADSyncKeys( account.accountId, "azure").then( keys => {
			let tempTokens = {
				tenantUrl: keys.baseUrl,
				secret: keys.secretKey
			};
			return Promise.resolve(tempTokens);
		});
	}

	canBeSelected(account: Account): Promise<boolean>{
		this.initServices();

		let isDenied = this.rbacAuthGuardService.isPermissionDeniedForUser(CategoryId.INTEGRATIONAZURE, ActionType.VIEW);
		return Promise.resolve(!isDenied);
	}

}
